<template>
    <div class="task-release--add-sync">
        <div class="content">
        <vxe-table
            class='atb-table header-table edit-table'
            border='full'
            height='100%'
            auto-resize
            resizable
            :data="monthTableData"
            ref="monthPlanData"
            
            :row-class-name="setRowClass"
            :merge-cells="mergeCells"
        >
            <vxe-table-column type='radio' width='40' align='center'>
              <template #radio="scope">
                  <template v-if="scope.rowIndex === 0">
                    <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                        <span>KPI工作</span>
                    </div>
                  </template>
                  <template v-else-if="scope.rowIndex === kpiLength + 1">
                    <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                        <span>例行工作</span>
                    </div>
                  </template>
                  <template v-else-if="scope.rowIndex === kpiLength + normalLength + 2">
                    <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                        <span>问题及创新工作</span>
                    </div>
                  </template>
                  <template v-else-if="scope.rowIndex === kpiLength + normalLength + createLength + 3">
                    <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                        <span>其他新增工作</span>
                    </div>
                  </template>
                   <template v-else>
                    <span title="选择/取消" :class="['vxe-cell--radio', scope.checked ? 'is--checked' : '']" @click.stop="selected(scope.row)">
                      <span class="vxe-radio--icon vxe-radio--checked-icon"></span>
                      <span class="vxe-radio--icon vxe-radio--unchecked-icon"></span>
                      <span class="vxe-radio--icon vxe-radio--indeterminate-icon"></span>
                    </span>
                  </template>
              </template>
            </vxe-table-column>
            <vxe-table-column field="workItemCategory" title="类别" width="120"></vxe-table-column>
            <vxe-table-column field="workItemContent" width="120" title="工作项目" :edit-render="{name: 'ElAutocomplete', enabled: disabled, autofocus: '.el-input__inner'}">
            </vxe-table-column>
            <vxe-table-column field="wholeTarget" title="总目标">
            </vxe-table-column>
            <vxe-table-column field="finishDate" width="120" title="最终完成时间">
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
            </vxe-table-column>
            </vxe-table>
        </div>
        <div class="form-wrap">
          <el-form :model="editForm" :rules="rules" ref="form" label-width='100px' class="atb-input" label-position="right">
            <el-row>
              <el-col :span="8">
                <el-form-item label="发布类型" prop="publishType">
                  <common-select ref="publishType" placeholder="发布类型" v-model="editForm.publishType" :disabled="isBatch" :list="typeList" optLabel="label" optValue="value" :clearable='false'></common-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">    
                <el-form-item label="指定人" prop="wkNos" v-if="isBatch" class="select-form-item">
                  <el-select 
                    v-model="editForm.wkNos" ref="selecter"
                    multiple :collapse-tags="isCollapse"
                    disabled max-height="200"
                    :placeholder="placeholder" class="multiple-person-select" clearable :popper-append-to-body="appendBody"
                  >
                    <el-option v-for="item in initWkList" :label="item.wkName" :value="item.wkNo" :key="item.wkNo"></el-option>
                  </el-select>
                  <el-button class="select-btn" type="primary" @click="showUserSelect" style="width: 56px;margin-left: 8px;padding: 12px 4px;">选择</el-button>
                </el-form-item>
                <el-form-item v-else label="指定人" prop="resWkNo" label-width="75px">
                  <selecter v-model="editForm.resWkNo" @selecterData="getSelecterData"></selecter>
                </el-form-item>

              </el-col>
              <el-col :span="6">    
                  <el-form-item label="权重" prop="weight" label-width="60px">
                    <el-autocomplete v-model="editForm.weight" :fetch-suggestions="querySearchWeight" placeholder="权重" @input="handleInputChange" clearable></el-autocomplete>
                  </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="btn-wrap">
            <el-button type="save" class="btn" @click="save">保存</el-button>
            <el-button type="saveAndRelease" class="btn" @click="saveAndRelease">发布</el-button>
            <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
        </div>
        <common-dialog ref="commonDialog" :title="dialogContent.title" :width="dialogContent.width" :showClose="true" :appendBody="true">
          <template slot="content">
            <component v-bind:is="dialogContent.componentName" :users="userData" :editData="editData" @updateUsers="updateUsers"></component>
          </template>
        </common-dialog>
    </div>
</template>
<script>
import editMixin from '@/mixins/edit.mixin'
import XEUtils from 'xe-utils'
export default {
  components: {
    selecter:()=>import('@/component/global/customerSelect'),
    UserSelectDialog:()=>import('@/component/global/UserSelectDialog'),
  },
  mixins: [ editMixin ],
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    },
    isBatch: Boolean,
    isCollapse: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      id: 'id',
      editForm: {},
      summaryData:{},
      weightList:[],
      mergeCells: [
        {row: 0, col: 0, rowspan: 1, colspan: 5},
        {row: 1, col: 0, rowspan: 1, colspan: 5},
        {row: 2, col: 0, rowspan: 1, colspan: 5},
        {row: 3, col: 0, rowspan: 1, colspan: 5}
      ],
      kpi: [],
      normal: [],
      create: [],
      other: [],
      selectedData:{},
      assignData:[],
      rules: {
        weight: [
          { required: true, message: '请选择权重', trigger: 'change' }
        ],
        resWkNo: [
          { required: true, message: '请选择指定人', trigger: 'change' },
        ],
        publishType: [
          { required: true, message: '请选择发布类型', trigger: 'change' },
        ],
        wkNos: [
          { required: true, message: '请选择指定人', trigger: 'change' },
        ],
      },
      typeList: [
        {label: '进入计划', value: '0'},
        {label: '进入待办', value: '1'},
      ],
      
      userData: [],
      initWkList: [],
      dialogContent: {},
    }
  },
  computed: {
      kpiLength() { //kpi数据长度 动态增加数据使用
        return this.kpi.length;
      },
      normalLength() {
        return this.normal.length;
      },
      createLength() {
        return this.create.length;
      },
      otherLength() {
        return this.other.length;
      },
      monthTableData() {
        return [{}, ...this.kpi, {}, ...this.normal, {}, ...this.create, {}, ...this.other];
      }
    },
  mounted() {
    if (!this.editForm.publishType) {
      this.$set(this.editForm, 'publishType', '0')
    }
    this.getMonthWorkList();
    this.getWeightDict();

    this.$nextTick(() => {
      this.$refs.form.clearValidate();
    })
  },
  methods:{
    querySearchWeight(queryString, cb) {
        let weightList = this.weightList;
        // 调用 callback 返回建议列表的数据
        cb(weightList);
    },
    getMonthWorkList() {
      this.$ajax.get(this.$api.month.MonthWorkDetail.list,{}).then((res) => {
        res.data&&this.filterSyncTableData(res.data.detailDtoList);
        if (!res.data) {
          this.monthTableData = [{}, {}, {}, {}];
        }
      });
    },
    filterSyncTableData(data) {
        if(XEUtils.isArray(data)){
        this.kpi = data.filter(val => val.workClassify == 0);
        this.normal = data.filter(val => val.workClassify == 10);
        this.create = data.filter(val => val.workClassify == 20);
        this.other = data.filter(val => val.workClassify == 30);
        }
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    setRowClass({rowIndex}) {
        if (rowIndex == 0 || rowIndex == this.kpiLength + 1 || rowIndex == this.kpiLength + this.normalLength + 2 || rowIndex == this.kpiLength + this.normalLength + this.createLength + 3) {
          return 'main-row';
        }
    },
    selected(row) {
      this.$refs.monthPlanData.setRadioRow(row);
      this.selectedData=row;
    },
    save(){
        //通过后提交数据
      const record = this.$refs.monthPlanData.getRadioRecord();
      if(!record){
        return this.$message.error('请勾选表格内的工作项');
      }
      if (record){
        if (!record.workItemContent || !record.wholeTarget || !record.finishDate) {
          return this.$message.error('计划内容填写不完整，工作项目、总目标、最终完成时间均不能为空');
        }
        this.$refs["form"].validate(valid=>{
        //通过后提交数据
        if(valid){
          const params={};
          params.workItemCategory=record.workItemCategory;
          params.workItemContent=record.workItemContent;
          params.workClassify=record.workClassify;
          params.wholeTarget=record.wholeTarget;
          params.finishDate=record.finishDate;
          params.weight=this.editForm.weight;
          params.resWkName=this.assignData.find(t=>t.jobNo===this.editForm.resWkNo)?this.assignData.find(t=>t.jobNo===this.editForm.resWkNo).name:'';
          params.resWkNo=this.editForm.resWkNo||'';
          if (this.isBatch) {
            params.detailResWkInfos = this.editForm.resWks;
          } else {
            const resWkObj = this.assignData.find(t => t.jobNo === this.editForm.resWkNo);
            params.detailResWkInfos = [{
              resWkName: resWkObj ? resWkObj.name : '',
              resWkNo: this.editForm.resWkNo,
            }]
            params.resWkName = resWkObj.name;
            params.resWkNo = this.editForm.resWkNo;
          }
          params.source = this.editForm.publishType == '1' ? 9 : 3;
          params.sourceId=record.id;
          params.publishType=this.editForm.publishType;
          const apiStr = this.isBatch ? this.$api.add.PublishMonthWork.batchAdd : this.$api.add.PublishMonthWork.adu;
          this.$ajax.post(apiStr, params).then(res=>{
            if(res.code === 0){
              this.$refs.form.resetFields();
              this.$message.success('保存成功');
              this.$emit('submitSuccess');
              this.editForm = {};
              if(!this.checked) this.$parent.$parent.hide();
            }
          });
          }
        });
      }
    },
    saveAndRelease(){
      const record = this.$refs.monthPlanData.getRadioRecord();
      if(!record){
        return this.$message.error('请勾选表格内的工作项');
      }
      if(record){
          if (!record.workItemContent || !record.wholeTarget || !record.finishDate) {
            return this.$message.error('计划内容填写不完整，工作项目、总目标、最终完成时间均不能为空');
          }
          this.$refs["form"].validate(valid=>{
          //通过后提交数据
            if(valid){
            const params={};
            params.workItemCategory=record.workItemCategory;
            params.workItemContent=record.workItemContent;
            params.workClassify=record.workClassify;
            params.wholeTarget=record.wholeTarget;
            params.finishDate=record.finishDate;
            params.weight=this.editForm.weight;
            params.resWkName=this.assignData.find(t=>t.jobNo===this.editForm.resWkNo)?this.assignData.find(t=>t.jobNo===this.editForm.resWkNo).name:'';
            params.resWkNo=this.editForm.resWkNo||'';
            if (this.isBatch) {
              params.detailResWkInfos = this.editForm.resWks;
            } else {
              const resWkObj = this.assignData.find(t => t.jobNo === this.editForm.resWkNo);
              params.detailResWkInfos = [{
                resWkName: resWkObj ? resWkObj.name : '',
                resWkNo: this.editForm.resWkNo,
              }]
              params.resWkName = resWkObj.name;
              params.resWkNo = this.editForm.resWkNo;
            }
            params.source = this.editForm.publishType == '1' ? 9 : 3;
            params.sourceId=record.id;
            params.publishType = this.editForm.publishType;
            const apiStr = this.isBatch ? this.$api.add.PublishMonthWork.batchSaveAndRelease : this.$api.add.PublishMonthWork.saveAndRelease;
            this.$ajax.put(apiStr, params).then(res=>{
              if (res.code === 0){
                this.$refs.form.resetFields();
                this.$message.success('发布成功');
                this.$emit('submitSuccess');
                this.editForm = {};
                if(!this.checked) this.$parent.$parent.hide();
                if(this.isBatch) this.$router.push('/manage/export-task/index')
              }
            });
          }
        });
        }
    },
    getSelecterData(data){
        this.assignData=data;
    },
    getWeightDict(){
        this.$ajax.get(this.$api.common.getDict,{ItemType:'WorkWeight'}).then((res)=>{
            if(res.code===0){
                this.weightList=[];
                res.data.rows.forEach(t=>{
                  this.weightList.push({value:eval(t.itemValue)});
                });
            }
        });
    },
    handleInputChange(value) {
      value = value + '';
      value = value.trim();
      // 只能输入数字
      value = value.replace(/[^\d]/g, '')
      if (value) {
        value = parseInt(value);
        if (value < 1) value = 1;
        if (value > 100) value = 100;
      }
      this.editForm.weight = value;
    },
    showUserSelect() {
      this.userData = JSON.parse(JSON.stringify(this.initWkList));
      this.dialogContent = {
        title: '人员',
        componentName: 'UserSelectDialog',
        width: '720px'
      }
      this.$refs.commonDialog.show()
    },
    updateUsers(list) {
      this.initWkList = list;
      this.editForm.wkNos = this.initWkList.map(item => item.wkNo);
      this.editForm.resWks = this.initWkList.map(item => {
        return {
          resWkName: item.wkName,
          resWkNo: item.wkNo,
        }
      });
    }
  },
 watch: {
      monthTableData: {
        handler() {
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: 5},
            {row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: 5},
            {row: this.kpiLength + this.normalLength + 2, col: 0, rowspan: 1, colspan: 5},
            {row: this.kpiLength + this.normalLength + this.createLength + 3, col: 0, rowspan: 1, colspan: 5},
          ];
        }
      }
    }
}
</script>
<style scoped lang='scss'>
  .task-release--add-sync {
    .content{
        height: 450px;
    }
    .el-button.el-button--save {
        color: #ffffff;
        background-color: #22b6a1;
        border-color: #22b6a1;
    }
    .el-button.el-button--saveAndRelease {
        background-color: #0dcc82;
        border-color: #0dcc82;
        color: #ffffff;
    }
    .el-button.el-button--clear {
        background-color: #F5BF2B;
        border-color: #F5BF2B;
        color: #ffffff;
    }
    .el-button {
        width: 110px;
        border-radius: 10px;
    }
    .btn-wrap{
         text-align: right;
         margin-top: 10px;
    }
    .form-wrap{
        margin: 10px 0px;
        .el-autocomplete{
            width: 100%;
        }
        .customerSelect{
            width: 100%;
        }
    }
    ::v-deep .header-table {
      overflow: auto;
      flex-grow: 1;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .main-row {
        .vxe-body--column {
          padding: 0;
        }
        .vxe-cell {
          padding: 0;
        }
      }
    }
    .kpi-add {
      height: 48px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      margin-top: -1px;
      padding: 0 15px;
      span {
        cursor: pointer;
      }
    }
  }
</style>
<style lang="scss">
  .multiple-person-select .el-input__suffix {
    display: none;
  }
</style>